import React, { useState, useEffect, useContext } from "react";
import "../ContentPages/style.css";
import SubmitButton from "../Buttons/SubmitButton";
import BackButton from "../Buttons/BackButton";
import { useForm } from "react-hook-form";
import { AppContext } from "../../contexts/AppContext";
import {
  getCountryNameById,
  getLabelFromId,
} from "../../Services/localStorage.tsx";
import { useNavigate } from "react-router-dom";
import Check from "../../assets/images/Check.svg";
import NameChange from "../NameChange/index.js";
import GenderChange from "../GenderChange/index.js";
import FieldError from "../FieldError/index.jsx";

const ReviewRenew = ({ handleNext, handleBack }) => {
  const { handleSubmit } = useForm();
  const navigate = useNavigate();

  const { appState, userFlows } = useContext(AppContext);

  const applicantData = appState.requestPayload.applicant;
  const eventData = appState.requestPayload.eventTypeSearch[0] || {};
  const changedName = appState.requestPayload.eventTypeSearch[1] || null;

  console.log("ReviewRenew Data:", applicantData, eventData, changedName);

  const [genderLabel, setGenderLabel] = useState("");
  const [addressCountryLabel, setAddressCountryLabel] = useState("");

  useEffect(() => {
    // Load passport data from localStorage if not already in state

    getLabelFromId("GenderReference", eventData?.genderId).then(
      (genderLabel) => {
        setGenderLabel(genderLabel);
      }
    );

    getCountryNameById(eventData.countryOfBirthId).then((countryName) => {
      setAddressCountryLabel(countryName);
    });
  }, [eventData?.genderId, eventData?.countryOfBirthId]);

  const onSubmit = () => {
    console.log("Confirmed Data:", applicantData);
    // if( !userFlows.showLiveness ) {
    //   navigate("/app/pre-referee");
    //   return;
    // }
    //always bypass referee check for renew
    handleNext();
  };

  return (
    <>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="intro">
          <h1 className="intro-title-mi" lang="mi-NZ">
            Arotakehia ō taipitopito
          </h1>
          <hr />
          <h1 className="intro-title">Review your details</h1>
          <div style={{ marginTop: 64 }}>
            <FieldError
              info={
                "Please check this information is correct. This is the information we'll use to verify your identity."
              }
              error={null}
            />

            {appState?.requestPayload?.supportingInformation
              ?.nameChangeSourceCode && <NameChange />}
            {appState?.requestPayload?.supportingInformation
              ?.genderSourceCode && <GenderChange />}
          </div>
          <div className="step-container spacer-40">
            <h2 className="step-title mb-2">Your verified details</h2>
            <div className="step-container-nospace">
              <div className="step-container-box">
                <p className="label">Given name(s)</p>
                <p className="value">{eventData?.givenNames || "-"}</p>
              </div>
              <div className="step-container-box">
                <p className="label">Surname or family name</p>
                <p className="value">{eventData?.familyName || "-"}</p>
              </div>

              <div className="step-container-box">
                <p className="label">Date of birth</p>
                <p className="value">
                  {applicantData?.dateOfBirth
                    ? new Date(applicantData.dateOfBirth).toLocaleDateString(
                        "en-NZ",
                        {
                          day: "2-digit",
                          month: "long",
                          year: "numeric",
                        }
                      )
                    : "-"}
                </p>
              </div>

              <div className="step-container-box">
                <p className="label">Place of birth (town/city)</p>
                <p className="value">
                  {applicantData?.placeOfBirth?.trim()
                    ? applicantData.placeOfBirth
                    : "Unknown"}
                  </p>
              </div>
              <div className="step-container-box">
                <p className="label">Country of birth</p>
                <p className="value">{addressCountryLabel}</p>
              </div>
              <div className="step-container-box">
                <p className="label">Gender</p>
                <p className="value">{genderLabel}</p>
              </div>
              {/* Add more fields if available in your localStorage data */}
            </div>
          </div>
        </div>

        <div className="step-button-container">
          <SubmitButton text={"Confirm"} type="submit" Icon={Check} />
          <BackButton text={"Back"} onClick={handleBack} />
        </div>
      </form>
    </>
  );
};

export default ReviewRenew;
